import React from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { Typography } from '@material-ui/core';

import { IRaster } from '../../../redux/layers/layerTypes';

type RasterProps = {
  style: IRaster;
};

function Raster({ style }: RasterProps) {
  const classes = useStyles();

  console.log(style);
  return (
    <div className={classes.row}>
      <div
        className={classes.box}
        style={{ backgroundColor: style.color, ...style.styles }}>
        {style.content}
      </div>
      <div className={classes.nameColumn}>
        <Typography variant="caption" className="name">
          {style.name}
        </Typography>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    row: {
      display: 'grid',
      gridTemplateColumns: '35px auto',
      alignItems: 'center',
      height: '30px'
    },
    nameColumn: {
      color: theme.palette.background.contrastText,
      display: 'flex',
      alignItems: 'center'
    },
    box: {
      height: '10px',
      width: '10px'
    }
  })
);

export default Raster;
